import React, { createElement } from 'react';
import './App.css';
import { comparePFC, PFC, reglesPFC } from './Rules';

const randomEnumValue = (enumeration: any) => {
  const values = Object.keys(enumeration);
  const enumKey = values[Math.floor(Math.random() * values.length)];
  return enumeration[enumKey];
}
let scoreP = 0
let scoreC = 0;
const divScoreP = document.createElement("div");
const divScoreC = document.createElement("div");
const divRule =  document.createElement("div");

function game(playerChoice: PFC) {
  let computerChoice: PFC = randomEnumValue(PFC);
  const divGame = document.getElementById("game");
  if (divGame != null) {
    divGame.appendChild(divRule)
  }
  if (comparePFC(playerChoice, computerChoice) < 0) {
    scoreC++;
    divRule.innerHTML = "You loose because " +  reglesPFC(playerChoice,computerChoice)
  }
  else if (comparePFC(playerChoice, computerChoice) > 0) {
    scoreP++;
    divRule.innerHTML =  "You win because " +  reglesPFC(playerChoice,computerChoice)
  }
  else {
    scoreC++;
    scoreP++;
    divRule.innerHTML = reglesPFC(playerChoice,computerChoice);
  }
  
  const d1 = document.getElementById("scC")
  const d2 = document.getElementById("scP")
  if (d1!=null && d2!=null){
    d1.innerHTML = ""+scoreC;
    d2.innerHTML = ""+scoreP;
  }
}

export function AppPFC() {
  return (
    <div className="App">
      <header className="App-header">
        <div> <h1>Welcome to Rock Paper Scissors</h1></div>
        <div id='game'>
          <img src={require('../src/assets/img/Scissors.jpg')} onClick={() => game(PFC.Scissors)} alt='Scissors' />
          <img src={require('../src/assets/img/Rock.jpg')} onClick={() => game(PFC.Rock)} alt='Rock' />
          <img src={require('../src/assets/img/Paper.jpg')} onClick={() => game(PFC.Paper)} alt='Paper' />
        </div>
        </header>
    </div>
  );
}

export default AppPFC;
